<template>
  <div class="employee-insurance-list-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>雇主险订单管理</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="自定义检索:">
              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_policyholder" placeholder="投保人" style="width: 200px;"></el-input>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_beneficiary" placeholder="按被保险人" style="width: 200px;"></el-input>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_policy_no" placeholder="保单号" style="width: 200px;"></el-input>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_mobile" placeholder="手机号码" style="width: 200px;"></el-input>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-date-picker v-model="searchForm.keyword_begintime" type="date" placeholder="开始时间" value-format="yyyy-MM-dd" style="width: 150px;"> </el-date-picker>
                  <el-date-picker v-model="searchForm.keyword_endtime" type="date" placeholder="结束时间" value-format="yyyy-MM-dd" style="width: 150px; margin-left: 10px;"> </el-date-picker>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.keyword_status" placeholder="请选择投保状态" style="width: 200px;">
                    <el-option label="未支付" value="1"></el-option>
                    <el-option label="已生效" value="4"></el-option>
                    <el-option label="待上传投保单" value="64"></el-option>
                    <el-option label="已支付,待出单" value="128"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.keyword_insure_type" placeholder="请选择投保类型" style="width: 200px;">
                    <el-option label="客户投保" value="1"></el-option>
                    <el-option label="代客投保" value="2"></el-option>
                    <el-option label="线下投保" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_seq_no" placeholder="平台单号" style="width: 200px;"></el-input>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.insurance_type" multiple filterable allow-create default-first-option placeholder="请选择保险公司类型" style="width: 250px;">
                    <el-option v-for="item in insuranceOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.keyword_settlement" placeholder="请选择结算渠道" style="width: 200px;">
                    <el-option label="恒丰经纪" value="1"></el-option>
                    <el-option label="中际心元" value="2"></el-option>
                    <el-option label="鼎盛" value="4"></el-option>
                    <el-option label="现金结算" value="16"></el-option>
                    <el-option label="北京丰融" value="32"></el-option>
                    <el-option label="四川人保-物流保险网" value="17"></el-option>
                    <el-option label="金联安" value="18"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-date-picker v-model="searchForm.keyword_effected" type="date" placeholder="生效时间" value-format="yyyy-MM-dd" style="width: 150px;"> </el-date-picker>
                  <el-date-picker v-model="searchForm.keyword_expired" type="date" placeholder="失效时间" value-format="yyyy-MM-dd" style="width: 150px; margin-left: 10px;"> </el-date-picker>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.keyword_invoice_received" placeholder="请选择发票状态" style="width: 200px;">
                    <el-option label="已收到" value="true"></el-option>
                    <el-option label="未收到" value="false"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-select v-model="searchForm.keyword_vat_invoice_open_type" placeholder="请选择开票类型" style="width: 200px;">
                    <el-option label="开票" value="1"></el-option>
                    <el-option label="不开票" value="2"></el-option>
                    <el-option label="待定" value="4"></el-option>
                    <el-option label="普票" value="8"></el-option>
                    <el-option label="专票" value="16"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template>
                <el-form-item>
                  <el-input v-model="searchForm.keyword_province" placeholder="省份" style="width: 180px;"></el-input>
                  <el-input v-model="searchForm.keyword_city" placeholder="城市" style="width: 180px; margin-left: 10px;"></el-input>
                </el-form-item>
              </template>

              <el-form-item>
                <el-input v-model="searchForm.autoChannel" placeholder="渠道商" style="width: 200px;"></el-input>
              </el-form-item>

              <el-form-item>
                <el-checkbox v-model="searchForm.time">按更新时间倒序</el-checkbox>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleAdd">添加保单</el-button>
                <el-button type="success" @click="handleExport">导出Excel</el-button>
                <span style="margin-left: 20px;">
                  <strong
                    >保费总额：<span style="color: #ff7300">{{ sum }}</span
                    >元</strong
                  >
                </span>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="tableData" border stripe style="width: 100%" v-loading="loading" element-loading-text="加载中...">
        <el-table-column prop="policyholder" label="投保人" width="220" align="center"></el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="220" align="center"></el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="200" align="center"></el-table-column>
        <el-table-column :formatter="formatPolicyChannel" prop="policy_channel" label="订单渠道" width="150" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="150" align="center"></el-table-column>
        <el-table-column :formatter="formatSource" prop="source" label="来源" width="110" align="center"></el-table-column>
        <el-table-column :formatter="formatInsuranceType" prop="insurance_type" label="保险公司" width="350" align="center"></el-table-column>
        <el-table-column prop="product_name" label="产品类型" width="200" align="center"></el-table-column>
        <el-table-column prop="driver_number" label="搬运工人" width="120" align="center"></el-table-column>
        <el-table-column prop="clerk_number" label="文员内勤" width="120" align="center"></el-table-column>
        <el-table-column prop="trucker_number" label="司机押运" width="120" align="center"></el-table-column>
        <el-table-column :formatter="formatMoney" prop="pay_price" label="累计保费" width="120" align="center"></el-table-column>
        <el-table-column :formatter="formatDate" prop="created_at" label="投保时间" width="240" align="center"></el-table-column>
        <el-table-column :formatter="formatDate" prop="effect_date" label="生效时间" width="240" align="center"></el-table-column>
        <el-table-column :formatter="formatDate" prop="expire_date" label="失效时间" width="240" align="center"></el-table-column>
        <el-table-column :formatter="formatStatus" prop="status" label="保单状态" width="90" align="center"></el-table-column>
        <el-table-column :formatter="formatVatInvoiceType" label="开票类型" width="80" align="center"></el-table-column>
        <el-table-column :formatter="formatInvoiceReceived" prop="is_invoice_received" label="发票状态" width="100" align="center"></el-table-column>
        <el-table-column label="操作" width="560" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleRegisterClaim(scope.row)">登记案件</el-button>
            <el-button v-if="canEdit(scope.row)" type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-else type="text" size="small" disabled style="color:#ccc;">编辑</el-button>
            <el-button v-if="canDiscount(scope.row)" type="text" size="small" @click="handleDiscount(scope.row)">保费打折</el-button>
            <el-button v-else type="text" size="small" disabled style="color:#ccc;">保费打折</el-button>
            <el-button v-if="canInputPolicyNo(scope.row)" type="text" size="small" @click="handlePolicyNo(scope.row)">保单号录入</el-button>
            <el-button v-else type="text" size="small" disabled style="color:#ccc;">保单号录入</el-button>
            <el-button v-if="canSurrender(scope.row)" type="text" size="small" @click="handleSurrender(scope.row)">退保</el-button>
            <el-button v-else type="text" size="small" disabled style="color:#ccc;">退保</el-button>
            <el-button type="text" size="small" @click="handleCheck(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="handleChangeChannel(scope.row)">变更渠道</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除订单</el-button>
            <!-- <el-button type="text" size="small" @click="handleNote(scope.row)">备注</el-button> -->
            <el-button type="text" size="small" @click="handleChangeMobile(scope.row)">修改手机号码</el-button>
            <el-button v-if="canChangePolicyNo(scope.row)" type="text" size="small" @click="handleChangePolicyNo(scope.row)">修改保单号</el-button>
            <el-button v-else type="text" size="small" disabled style="color:#ccc;">修改保单号</el-button>
            <el-button type="text" size="small" @click="handleCloseAdd(scope.row)">{{ scope.row.is_close_add ? '开启加人' : '关闭加人' }}</el-button>
            <el-button type="text" size="small" @click="handleInvoiceReceived(scope.row)">{{ scope.row.is_invoice_received ? '取消收到的发票' : '已收到发票' }}</el-button>
            <!-- <el-button type="text" size="small" @click="handlePolicyAudit(scope.row)">保单审核</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 查看详情组件 -->
    <ViewDetail :visible.sync="viewDetailVisible" :row-data="currentRow" />

    <!-- 编辑订单组件 -->
    <EditOrder
      :visible.sync="editOrderVisible"
      :current-row="currentRow"
      :allow-substitute="canSubstitute(currentRow)"
      action="edit"
      @success="fetchData"
    />

    <!-- 保费打折组件 -->
    <Discount :visible.sync="discountVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 保单号录入组件 -->
    <InputPolicyNo :visible.sync="inputPolicyNoVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 退保组件 -->
    <Surrender :visible.sync="surrenderVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 变更渠道组件 -->
    <ChangeChannel :visible.sync="changeChannelVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 备注组件 -->
    <Note :visible.sync="noteVisible" :row-data="currentRow" />

    <!-- 修改手机号码组件 -->
    <ChangeMobile :visible.sync="changeMobileVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 修改保单号组件 -->
    <ChangePolicyNo :visible.sync="changePolicyNoVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 发票管理组件 -->
    <InvoiceReceived :visible.sync="invoiceReceivedVisible" :row-data="currentRow" @success="fetchData" />

    <!-- 上传授权书组件 -->
    <UploadAuthorization :visible.sync="uploadAuthorizationVisible" :row-data="currentRow" :mode="authorizationMode" @success="fetchData" />

    <!-- 挂账金额组件 -->
    <Buyer :visible.sync="buyerVisible" :order-info="currentRow" />

    <!-- 雇主险理赔登记案件组件 -->
    <ClaimEditor
      :visible.sync="claimEditorVisible"
      mode="create"
      :risk-type="2"
      :policy-no="registerPolicyNo"
      @saved="fetchData"
    />
  </div>
</template>

<script>
import { ygbOrderList, ygbExportOrder, ygbOrderInfo, ygbOrderDelete, ygbOrderPolicyCallback, getChannelList, getInsuranceCompanyList, ygbOrderCloseAdd, ygbOrderPolicyAudit, ygbOrderInvoiceUpdate } from '@/api/member.js'
import { formatDate, formatMoney } from '@/utils/formatter'
import ExportJsonExcel from 'js-export-excel'

// 导入组件
import ViewDetail from './components/ViewDetail.vue'
import EditOrder from './components/EditOrder.vue'
import Discount from './components/Discount.vue'
import InputPolicyNo from './components/InputPolicyNo.vue'
import Surrender from './components/Surrender.vue'
import ChangeChannel from './components/ChangeChannel.vue'
import Note from './components/Note.vue'
import ChangeMobile from './components/ChangeMobile.vue'
import ChangePolicyNo from './components/ChangePolicyNo.vue'
import InvoiceReceived from './components/InvoiceReceived.vue'
import UploadAuthorization from './components/UploadAuthorization.vue'
import Buyer from './components/Buyer.vue'
import ClaimEditor from '../ClaimsManagement/components/ClaimEditor.vue'

export default {
  name: 'EmployeeInsuranceList',
  components: {
    ViewDetail,
    EditOrder,
    Discount,
    InputPolicyNo,
    Surrender,
    ChangeChannel,
    Note,
    ChangeMobile,
    ChangePolicyNo,
    InvoiceReceived,
    UploadAuthorization,
    Buyer,
    ClaimEditor
  },
  data() {
    return {
      searchForm: {
        keyword_policyholder: '',
        keyword_beneficiary: '',
        keyword_policy_no: '',
        keyword_mobile: '',
        keyword_begintime: '',
        keyword_endtime: '',
        keyword_status: '',
        keyword_insure_type: '',
        keyword_seq_no: '',
        insurance_type: [],
        keyword_settlement: '',
        keyword_effected: '',
        keyword_expired: '',
        keyword_invoice_received: '', // 修改为字符串类型
        keyword_vat_invoice_open_type: '',
        keyword_province: '',
        keyword_city: '',
        autoChannel: '',
        time: false
      },
      insuranceOptions: [
        { id: 2, name: '大地财产保险有限公司' },
        { id: 16, name: '信达财产保险股份有限公司' },
        { id: 128, name: '中国人民保险集团股份有限公司' }
      ],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      total: 0,
      sum: 0, // 保费总额

      // 组件显示控制
      viewDetailVisible: false,
      editOrderVisible: false,
      discountVisible: false,
      inputPolicyNoVisible: false,
      surrenderVisible: false,
      changeChannelVisible: false,
      noteVisible: false,
      changeMobileVisible: false,
      changePolicyNoVisible: false,
      invoiceReceivedVisible: false,
      uploadAuthorizationVisible: false,
      authorizationMode: 'add', // 授权书组件模式：add-上传，view-查看
      buyerVisible: false, // 挂账金额组件显示状态
      claimEditorVisible: false,
      registerPolicyNo: '',

      // 当前操作的行数据
      currentRow: {}
    }
  },
  methods: {
    // 格式化金额显示
    formatMoney(row, column, cellValue) {
      if (cellValue != null && cellValue !== '') {
        // 使用项目中已有的工具函数格式化金额
        return formatMoney(cellValue, '')
      }
      return '0.00'
    },

    // 格式化日期显示
    formatDate(row, column, cellValue) {
      if (cellValue && new Date(cellValue).getFullYear() !== 1) {
        // 使用项目中已有的工具函数格式化日期
        return formatDate(cellValue, 'YYYY-MM-DD HH:mm:ss')
      }
      return ''
    },

    // 格式化是否关闭加人
    formatCloseAdd(row, column, cellValue) {
      return cellValue ? '是' : '否'
    },

    // 格式化保单状态
    formatStatus(row, column, cellValue) {
      const statusMap = {
        '1': '待支付',
        '2': '已取消',
        '4': '已生效',
        '8': '已过期',
        '16': '理赔中',
        '32': '理赔完成',
        '64': '待上传投保单',
        '128': '已支付,待出单'
      }
      return statusMap[cellValue] || ''
    },

    // 格式化投保类型
    formatInsureType(row, column, cellValue) {
      const typeMap = {
        '1': '客户投保',
        '2': '代客投保',
        '4': '线下投保'
      }
      return typeMap[cellValue] || ''
    },

    // 格式化来源
    formatSource(row, column, cellValue) {
      const sourceMap = {
        '1': 'PC',
        '2': 'Mobile',
        '4': 'iOS',
        '8': 'Android',
        '16': 'API'
      }
      return sourceMap[cellValue] || ''
    },

    // 格式化结算渠道
    formatSettlementChannel(row, column, cellValue) {
      const channelMap = {
        '1': '恒丰经纪',
        '2': '中际心元',
        '4': '鼎盛',
        '16': '现金结算',
        '32': '北京丰融',
        '17': '四川人保-物流保险网',
        '18': '金联安'
      }
      return channelMap[cellValue] || '未知'
    },

    // 格式化审核状态
    formatCheckedStatus(row, column, cellValue) {
      return cellValue ? '已审核' : '未审核'
    },

    // 格式化发票状态
    formatInvoiceReceived(row, column, cellValue) {
      return cellValue ? '已收到' : '未收到'
    },

    // 格式化开票类型
    formatVatInvoiceType(row) {
      // 根据vat_invoice_open_type来确定显示内容
      if (row.vat_invoice_open_type == 1) {
        // 开票状态，根据vat_invoice_type显示具体类型
        if (row.vat_invoice_type == 1) {
          return '普票'
        } else if (row.vat_invoice_type == 2) {
          return '专票'
        } else {
          return '开票'
        }
      } else if (row.vat_invoice_open_type == 2) {
        return '不开票'
      } else if (row.vat_invoice_open_type == 4) {
        return '待定'
      } else {
        return '不开票' // 默认显示不开票
      }
    },

    // 格式化订单渠道
    formatPolicyChannel(row, column, cellValue) {
      if (cellValue != '' && row.alias) {
        return cellValue + '(' + row.alias + ')'
      } else if (row.alias) {
        return row.alias
      }
      return cellValue || ''
    },

    // 格式化顶级渠道
    formatTopChannel(row) {
      if (row.top_channel && row.top_alias) {
        return row.top_channel + '(' + row.top_alias + ')'
      } else if (row.top_alias) {
        return row.top_alias
      }
      return row.top_channel || ''
    },

    // 格式化保险公司
    formatInsuranceType(row, column, cellValue) {
      if (!cellValue) return ''

      // 这里需要根据insuranceOptions来查找对应的文本
      const insurance = this.insuranceOptions.find(item => item.id == cellValue || String(item.id) === String(cellValue))
      return insurance ? insurance.name : ''
    },

    // 格式化保单信息回传
    formatPolicyNotify(row, column, cellValue) {
      // 如果有保单号且状态为已生效
      if (row.policy_no && row.status == 4) {
        if (cellValue) {
          return '已回传'
        } else {
          return '手动回传'
        }
      } else {
        return '-'
      }
    },

    // 判断是否可以编辑
    canEdit(row) {
      // 1 + 4 + 64 + 128 = 197
      return (row.status & 197) !== 0
    },
    // 判断是否可以保费打折和保单号录入
    canDiscount(row) {
      // 1 + 4 + 64 + 128 = 197
      return (row.status & 193) !== 0
    },
    canInputPolicyNo(row) {
      return this.canDiscount(row)
    },
    // 判断是否可以换人和退保
    canSubstitute(row) {
      return row.status === 4 && (row.clerk_number !== 0 || row.driver_number !== 0 || row.trucker_number !== 0)
    },
    canSurrender(row) {
      return this.canSubstitute(row)
    },
    // 判断是否可以修改保单号
    canChangePolicyNo(row) {
      return row.status === 4
    },
    handleReset() {
      // 重置搜索条件
      this.searchForm = {
        keyword_policyholder: '',
        keyword_beneficiary: '',
        keyword_policy_no: '',
        keyword_mobile: '',
        keyword_begintime: '',
        keyword_endtime: '',
        keyword_status: '',
        keyword_insure_type: '',
        keyword_seq_no: '',
        insurance_type: [],
        keyword_settlement: '',
        keyword_effected: '',
        keyword_expired: '',
        keyword_invoice_received: '', // 重置为字符串类型
        keyword_vat_invoice_open_type: '',
        keyword_province: '',
        keyword_city: '',
        autoChannel: '',
        time: false
      }
      this.currentPage = 1
      this.fetchData()
    },
    handleSearch() {
      // 搜索逻辑
      this.currentPage = 1
      this.fetchData()
    },
    handleAdd() {
      // 添加保单逻辑
      // 初始化一个空的订单数据对象
      const emptyOrderData = {
        id: '',
        policyholder: '',
        beneficiary: '',
        province: '',
        city: '',
        policy_no: '',
        seq_no: '',
        policy_channel: '',
        alias: '',
        mobile: '',
        product_name: '',
        driver_price: 0,
        clerk_price: 0,
        trucker_price: 0,
        driver_number: 0,
        clerk_number: 0,
        trucker_number: 0,
        must_price: 0,
        actual_price: 0,
        status: 0,
        created_at: '',
        effect_date: '',
        expire_date: '',
        settlement_channel: '',
        vat_invoice_open_type: 2, // 默认不开票
        vat_invoice_type: 1,
        vat_invoice_title: 1,
        individual_title_name: '',
        tax_name: '',
        tax_no: '',
        tax_address: '',
        tax_mobile: '',
        tax_bank: '',
        tax_bank_no: '',
        license_file_url: '',
        tax_file_url: '',
        vat_file_url: '',
        change_file: '',
        excel_file_url: '',
        // 添加action参数
        action: 'add',
        // 初始化员工列表
        employee_list: [{ name: '', idcard: '', type: 1, is_highlight: false }],
        // 初始化保单文件和投保单文件
        policy_file: [],
        proposal_url: []
      }

      this.currentRow = emptyOrderData
      // 使用ViewDetail组件，传入add action
      this.viewDetailVisible = true
    },
    handleExport() {
      const params = this.buildSearchParams()
      ygbExportOrder(params)
        .then(response => {
          const rows = response && response.rows ? response.rows : []
          if (!rows.length) {
            this.$message.warning('没有查询到可导出的数据')
            return
          }

          const sheetData = rows.map(row => ({
            policyholder: row.policyholder,
            beneficiary: row.beneficiary,
            province: row.province,
            city: row.city,
            seq_no: row.seq_no,
            policy_no: row.policy_no,
            vat_invoice_type: this.formatVatInvoiceType(row),
            policy_channel: this.formatPolicyChannel(row, null, row.policy_channel),
            top_channel: this.formatTopChannel(row),
            mobile: row.mobile,
            source: this.formatSource(row, null, row.source),
            insurance_type: this.formatInsuranceType(row, null, row.insurance_type),
            product_name: row.product_name,
            driver_number: row.driver_number,
            clerk_number: row.clerk_number,
            trucker_number: row.trucker_number,
            driver_price: Number(row.driver_price || 0) / 100,
            clerk_price: Number(row.clerk_price || 0) / 100,
            trucker_price: Number(row.trucker_price || 0) / 100,
            must_price: Number(row.must_price || 0) / 100,
            actual_price: Number(row.actual_price || 0) / 100,
            pay_price: Number(row.pay_price || 0) / 100,
            created_at: this.formatDate(row, null, row.created_at),
            status: this.formatStatus(row, null, row.status),
            is_invoice_received: this.formatInvoiceReceived(row, null, row.is_invoice_received),
            note: row.note,
            tax_address: row.tax_address,
            tax_bank: row.tax_bank,
            tax_bank_no: row.tax_bank_no,
            tax_mobile: row.tax_mobile,
            tax_name: row.tax_name,
            tax_no: row.tax_no,
            effect_date: this.formatDate(row, null, row.effect_date),
            expire_date: this.formatDate(row, null, row.expire_date)
          }))
          new ExportJsonExcel({
            fileName: '睿保雇主险订单',
            datas: [
              {
                sheetData,
                sheetName: '雇主险订单',
                sheetHeader: [
                  '保险人',
                  '被保险人',
                  '省份',
                  '城市',
                  '平台单号',
                  '保单号',
                  '开票类型',
                  '订单渠道',
                  '顶级渠道',
                  '手机号',
                  '来源',
                  '保险公司',
                  '产品类型',
                  '搬运工人(人)',
                  '文员内勤(人)',
                  '司机押运(人)',
                  '搬运工人单价(元)',
                  '文员内勤单价(元)',
                  '司机押运单价(元)',
                  '录单应付保费(元)',
                  '录单实付(元)',
                  '累计保费(元)',
                  '投保时间',
                  '保单状态',
                  '发票状态',
                  '保单描述',
                  '税务登记地址',
                  '税务开户银行名称',
                  '税务开户银行账号',
                  '税务登记联系电话',
                  '纳税人名称',
                  '税务登记号',
                  '生效时间',
                  '失效时间'
                ]
              }
            ]
          }).saveExcel()
          this.$message.success('导出成功')
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败: ' + (error.message || '未知错误'))
        })
    },
    normalizeArrayValue(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      if (typeof value !== 'string') return [value]

      const text = value.trim()
      if (!text) return []
      try {
        const parsed = JSON.parse(text)
        return Array.isArray(parsed) ? parsed : [parsed]
      } catch (error) {
        return text.split(',').map(item => item.trim()).filter(Boolean)
      }
    },
    normalizePolicyFiles(value) {
      return this.normalizeArrayValue(value)
        .map((file, index) => {
          if (typeof file === 'string') {
            return { name: `保单文件${index + 1}`, url: file }
          }
          return {
            ...file,
            name: file.name || `保单文件${index + 1}`,
            url: file.url || file.path || ''
          }
        })
        .filter(file => file.url)
    },
    normalizeProposalFiles(value) {
      return this.normalizeArrayValue(value)
        .map(file => (typeof file === 'string' ? file : file.url || file.path || ''))
        .filter(Boolean)
    },
    handleView(row) {
      this.loading = true
      ygbOrderInfo({ id: row.id, platform_type: 8 })
        .then(response => {
          this.loading = false
          if (response && response.err_code === 0 && response.order) {
            const order = response.order
            this.currentRow = {
              ...order,
              policyholder: order.policyholder || order.company_name || '',
              beneficiary: order.beneficiary || '',
              employee_list: Array.isArray(order.employee_list) ? order.employee_list : [],
              policy_file: this.normalizePolicyFiles(order.policy_file),
              proposal_url: this.normalizeProposalFiles(order.proposal_url),
              action: 'view'
            }
            this.viewDetailVisible = true
          } else {
            this.$message.error((response && response.err_msg) || '获取订单详情失败')
          }
        })
        .catch(error => {
          this.loading = false
          console.error('获取订单详情失败:', error)
          this.$message.error('获取订单详情失败')
        })
    },
    handleRegisterClaim(row) {
      const policyNo = String(row.policy_no || '').trim()
      if (!policyNo) {
        this.$message.warning('该订单尚未录入保单号，无法登记案件')
        return
      }
      this.registerPolicyNo = policyNo
      this.claimEditorVisible = true
    },
    handleEdit(row) {
      // 编辑逻辑 - 使用EditOrder组件
      this.currentRow = {
        ...row,
        orderNo: row.seq_no || row.id,
        policyholderName: row.policyholder || '',
        beneficiaryName: row.beneficiary || '',
        provinceName: row.province || '',
        cityName: row.city || '',
        mobile: row.mobile || '',
        policyNo: row.policy_no || '',
        notes: row.notes || '',
        invoiceReceipt: row.invoice_receipt || false,
        closeAddFunction: row.close_add_function || false,
        employees: row.employee_list || []
      }
      this.editOrderVisible = true
    },
    handleDiscount(row) {
      // 保费打折逻辑
      this.currentRow = { ...row }
      this.discountVisible = true
    },
    handlePolicyNo(row) {
      // 保单号录入逻辑
      this.currentRow = { ...row }
      this.inputPolicyNoVisible = true
    },
    handleSurrender(row) {
      // 退保逻辑
      this.currentRow = { ...row }
      this.surrenderVisible = true
    },
    handleCheck(row) {
      // 修改逻辑 - 先获取完整订单信息
      this.loading = true
      ygbOrderInfo({ id: row.id, platform_type: 8 })
        .then(response => {
          this.loading = false
          if (response && response.err_code === 0) {
            // 处理返回的数据，确保字段正确
            const orderData = {
              ...response.order,
              // 确保关键字段存在
              policyholder: response.order.policyholder || '',
              beneficiary: response.order.beneficiary || '',
              province: response.order.province || '',
              city: response.order.city || '',
              policy_no: response.order.policy_no || '',
              seq_no: response.order.seq_no || '',
              policy_channel: response.order.policy_channel || '',
              alias: response.order.alias || '',
              mobile: response.order.mobile || '',
              product_name: response.order.product_name || '',
              driver_price: response.order.driver_price !== undefined ? response.order.driver_price : 0,
              clerk_price: response.order.clerk_price !== undefined ? response.order.clerk_price : 0,
              trucker_price: response.order.trucker_price !== undefined ? response.order.trucker_price : 0,
              driver_number: response.order.driver_number !== undefined ? response.order.driver_number : 0,
              clerk_number: response.order.clerk_number !== undefined ? response.order.clerk_number : 0,
              trucker_number: response.order.trucker_number !== undefined ? response.order.trucker_number : 0,
              must_price: response.order.must_price !== undefined ? response.order.must_price : 0,
              actual_price: response.order.actual_price !== undefined ? response.order.actual_price : 0,
              status: response.order.status !== undefined ? response.order.status : 0,
              created_at: response.order.created_at || '',
              effect_date: response.order.effect_date || '',
              expire_date: response.order.expire_date || '',
              settlement_channel: response.order.settlement_channel || '',
              vat_invoice_open_type: response.order.vat_invoice_open_type !== undefined ? response.order.vat_invoice_open_type : 2, // 默认不开票
              vat_invoice_type: response.order.vat_invoice_type !== undefined ? response.order.vat_invoice_type : 0,
              vat_invoice_title: response.order.vat_invoice_title !== undefined ? response.order.vat_invoice_title : 0,
              individual_title_name: response.order.individual_title_name || '',
              tax_name: response.order.tax_name || '',
              tax_no: response.order.tax_no || '',
              tax_address: response.order.tax_address || '',
              tax_mobile: response.order.tax_mobile || '',
              tax_bank: response.order.tax_bank || '',
              tax_bank_no: response.order.tax_bank_no || '',
              license_file_url: response.order.license_file_url || '',
              tax_file_url: response.order.tax_file_url || '',
              vat_file_url: response.order.vat_file_url || '',
              change_file: response.order.change_file || '',
              excel_file_url: response.order.excel_file_url || '',
              // 添加action参数
              action: 'check',
              // 处理员工列表
              employee_list: response.order.employee_list && Array.isArray(response.order.employee_list) ? response.order.employee_list : [],
              // 处理保单文件
              policy_file: response.order.policy_file && Array.isArray(response.order.policy_file) ? response.order.policy_file : [],
              // 处理投保单文件
              proposal_url: response.order.proposal_url ? (typeof response.order.proposal_url === 'string' ? JSON.parse(response.order.proposal_url) : response.order.proposal_url) : []
            }

            this.currentRow = orderData
            this.viewDetailVisible = true
          } else {
            this.$message.error(response.err_msg || '获取订单详情失败')
          }
        })
        .catch(error => {
          this.loading = false
          console.error('获取订单详情失败:', error)
          this.$message.error('获取订单详情失败')
        })
    },
    handleChangeChannel(row) {
      // 变更渠道逻辑
      this.currentRow = { ...row }
      this.changeChannelVisible = true
    },
    handleDelete(row) {
      // 删除订单逻辑
      this.$confirm('确定要删除这个订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ygbOrderDelete({ id: row.id })
            .then(response => {
              if (response && response.err_code === 0) {
                this.$message.success('删除成功')
                this.fetchData()
              } else {
                this.$message.error(response.err_msg || '删除失败')
              }
            })
            .catch(error => {
              console.error('删除失败:', error)
              this.$message.error('删除失败')
            })
        })
        .catch(() => {
          // 取消删除
        })
    },
    handleNote(row) {
      // 备注逻辑
      this.currentRow = { ...row }
      this.noteVisible = true
    },
    handleChangeMobile(row) {
      // 修改手机号码逻辑
      this.currentRow = { ...row }
      this.changeMobileVisible = true
    },
    handleChangePolicyNo(row) {
      // 修改保单号逻辑
      this.currentRow = { ...row }
      this.changePolicyNoVisible = true
    },
    handleCloseAdd(row) {
      // 关闭/开启加人逻辑
      const action = row.is_close_add ? '开启' : '关闭'
      this.$confirm(`您确认想要${action}订单加人功能吗？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = {
            id: row.id,
            is_close_add: !row.is_close_add
          }
          ygbOrderCloseAdd(data)
            .then(response => {
              if (response && response.err_code === 0) {
                this.$message.success('修改成功')
                this.fetchData()
              } else {
                this.$message.error(response.err_msg || '修改失败')
              }
            })
            .catch(error => {
              console.error('修改失败:', error)
              this.$message.error('修改失败')
            })
        })
        .catch(() => {
          // 取消操作
        })
    },
    async handleInvoiceReceived(row) {
      if (row.is_invoice_received) {
        // 调用发票更新API
        const response = await ygbOrderInvoiceUpdate({
          order_id: row.id,
          is_invoice_received: false
        })

        if (response.err_code === 0) {
          this.$message.success('取消成功')
          this.fetchData()
        } else {
          this.$message.error('保存失败: ' + response.data.err_msg)
        }
      } else {
        // 打开发票管理对话框
        this.currentRow = row
        this.invoiceReceivedVisible = true
      }
    },
    handlePolicyCallback(row) {
      // 手动回传逻辑
      this.$confirm('确定要手动回传保单信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = {
            order_id: row.id,
            product_alias: 'ygb'
          }
          ygbOrderPolicyCallback(data)
            .then(response => {
              if (response && response.err_code === 0) {
                this.$message.success('回传成功')
                this.fetchData()
              } else {
                this.$message.error(response.err_msg || '回传失败')
              }
            })
            .catch(error => {
              console.error('回传失败:', error)
            })
        })
        .catch(() => {
          // 取消操作
        })
    },
    handleAuthorization(row) {
      // 根据是否已有授权书设置不同的模式
      this.currentRow = row
      this.authorizationMode = row.authorization ? 'view' : 'add'
      this.uploadAuthorizationVisible = true
    },
    handlePolicyAudit(row) {
      // 保单审核逻辑
      this.$confirm('确定要进行保单审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = {
            order_id: row.id
          }
          ygbOrderPolicyAudit(data)
            .then(response => {
              if (response && response.err_code === 0) {
                this.$message.success('审核成功')
                this.fetchData()
              } else {
                this.$message.error(response.err_msg || '审核失败')
              }
            })
            .catch(error => {
              console.error('审核失败:', error)
              this.$message.error('审核失败')
            })
        })
        .catch(() => {
          // 取消操作
        })
    },
    handleBuyer(row) {
      // 显示挂账金额组件
      this.currentRow = row
      this.buyerVisible = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    buildSearchParams() {
      const params = {
        page: this.currentPage,
        rows: this.pageSize,
        platform_type: 8, // 员工保平台类型
        staging: false
      }

      // 添加时间倒序参数
      if (this.searchForm.time) {
        params.is_update_at = true
      }

      if (this.searchForm.keyword_policyholder) params.policyholder = this.searchForm.keyword_policyholder
      if (this.searchForm.keyword_beneficiary) params.beneficiary = this.searchForm.keyword_beneficiary
      if (this.searchForm.keyword_policy_no) params.policy_no = this.searchForm.keyword_policy_no
      if (this.searchForm.keyword_mobile) params.mobile = this.searchForm.keyword_mobile
      if (this.searchForm.keyword_begintime) params.begin_date = Math.floor(new Date(this.searchForm.keyword_begintime + ' 00:00:00').getTime() / 1000)
      if (this.searchForm.keyword_endtime) params.end_date = Math.floor(new Date(this.searchForm.keyword_endtime + ' 23:59:59').getTime() / 1000)
      if (this.searchForm.keyword_status) params.status = this.searchForm.keyword_status
      if (this.searchForm.keyword_insure_type) params.insure_type = this.searchForm.keyword_insure_type
      if (this.searchForm.keyword_seq_no) params.seq_no = this.searchForm.keyword_seq_no
      if (this.searchForm.insurance_type && this.searchForm.insurance_type.length > 0) {
        params.insurance_type_list = '(' + this.searchForm.insurance_type.join(',') + ')'
      }
      if (this.searchForm.keyword_settlement) params.settlement_channel = this.searchForm.keyword_settlement
      if (this.searchForm.keyword_effected) params.effected_at = Math.floor(new Date(this.searchForm.keyword_effected + ' 00:00:00').getTime() / 1000)
      if (this.searchForm.keyword_expired) params.expired_at = Math.floor(new Date(this.searchForm.keyword_expired + ' 23:59:59').getTime() / 1000)
      if (this.searchForm.keyword_invoice_received !== '') {
        params.is_invoice_received = this.searchForm.keyword_invoice_received === 'true' || this.searchForm.keyword_invoice_received === true ? 'true' : 'false'
      }
      if (this.searchForm.keyword_vat_invoice_open_type) params.vat_invoice_open_type = this.searchForm.keyword_vat_invoice_open_type
      if (this.searchForm.keyword_province) params.province = this.searchForm.keyword_province
      if (this.searchForm.keyword_city) params.city = this.searchForm.keyword_city

      // 渠道商搜索
      if (this.searchForm.autoChannel) {
        // 这里需要根据渠道商名称获取渠道ID
        params.channel_id = this.searchForm.autoChannel
      }

      return params
    },
    fetchData() {
      // 获取数据逻辑
      this.loading = true
      const params = this.buildSearchParams()

      ygbOrderList(params)
        .then(response => {
          if (response && response.err_code === 0) {
            // 处理返回的数据，确保字段正确
            this.tableData =
              (response.rows &&
                response.rows.map(item => {
                  return {
                    ...item,
                    // 确保关键字段存在
                    policyholder: item.policyholder || '',
                    beneficiary: item.beneficiary || '',
                    province: item.province || '',
                    city: item.city || '',
                    policy_no: item.policy_no || '',
                    seq_no: item.seq_no || '',
                    vat_invoice_type: item.vat_invoice_type !== undefined ? item.vat_invoice_type : 0,
                    policy_channel: item.policy_channel || '',
                    alias: item.alias || '',
                    top_channel: item.top_channel || '',
                    top_alias: item.top_alias || '',
                    mobile: item.mobile || '',
                    product_name: item.product_name || '',
                    status: item.status !== undefined ? item.status : 0,
                    must_price: item.must_price !== undefined ? item.must_price : 0,
                    actual_price: item.actual_price !== undefined ? item.actual_price : 0,
                    pay_price: item.pay_price !== undefined ? item.pay_price : 0,
                    created_at: item.created_at || null,
                    effect_date: item.effect_date || null,
                    expire_date: item.expire_date || null,
                    is_invoice_received: item.is_invoice_received !== undefined ? item.is_invoice_received : false,
                    insurance_type: item.insurance_type || 0,
                    driver_number: item.driver_number || 0,
                    clerk_number: item.clerk_number || 0,
                    trucker_number: item.trucker_number || 0,
                    driver_price: item.driver_price !== undefined ? item.driver_price : 0,
                    clerk_price: item.clerk_price !== undefined ? item.clerk_price : 0,
                    trucker_price: item.trucker_price !== undefined ? item.trucker_price : 0,
                    source: item.source || 0,
                    settlement_channel: item.settlement_channel || 0,
                    checked: item.checked !== undefined ? item.checked : false,
                    insure_type: item.insure_type || 0,
                    note: item.note || '',
                    policy_notify_success: item.policy_notify_success !== undefined ? item.policy_notify_success : false,
                    vat_invoice_open_type: item.vat_invoice_open_type !== undefined ? item.vat_invoice_open_type : 2, // 默认不开票
                    is_close_add: item.is_close_add !== undefined ? item.is_close_add : false
                  }
                })) ||
              []

            this.total = response.total || 0
            // 保费总额转换为元并保留两位小数
            this.sum = response.sum ? (response.sum / 100).toFixed(2) : '0.00'
          } else {
            this.tableData = []
            this.total = 0
            this.sum = '0.00'
            // 显示错误信息
            this.$message.error(response ? response.err_msg || '获取数据失败' : '获取数据失败')
          }
          this.loading = false
        })
        .catch(error => {
          console.error('获取雇主险订单列表失败:', error)
          this.tableData = []
          this.total = 0
          this.sum = '0.00'
          this.loading = false
          this.$message.error('获取数据失败: ' + (error.message || '未知错误'))
        })
    }
  },
  mounted() {
    this.fetchData()
    // 获取保险公司列表
    getInsuranceCompanyList({ type: 1 })
      .then(response => {
        if (response && response.err_code === 0) {
          this.insuranceOptions = response.rows || []
        } else {
          console.error('获取保险公司列表失败:', response ? response.err_msg : '未知错误')
        }
      })
      .catch(error => {
        console.error('获取保险公司列表失败:', error)
        this.$message.error('获取保险公司列表失败: ' + (error.message || '未知错误'))
      })

    // 获取渠道列表
    getChannelList()
      .then(response => {
        if (response && response.err_code === 0) {
          // 这里可以初始化渠道商自动完成组件
          console.log('渠道列表:', response.rows)
        } else {
          console.error('获取渠道列表失败:', response ? response.err_msg : '未知错误')
        }
      })
      .catch(error => {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败: ' + (error.message || '未知错误'))
      })
  }
}
</script>

<style lang="less" scoped>
.employee-insurance-list-container {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
